module.exports = __webpack_public_path__ + "static/dog-with-wag-tag-tablet-775d4b719ebd9ab76ae41ec66cdba980.png";